import React from "react";
import { Pagination } from "@pd/pd-ui-kit";
import { useTranslation } from "react-i18next";

import CreateAdditional from "~/pages/ListOfDocuments/Modals/CreateAdditional";
import CreateAdditionalArr from "~/pages/ListOfDocuments/Modals/CreateAdditionalArr";
import EditAdditional from "~/pages/ListOfDocuments/Modals/EditAdditional";
import HistoryContract from "~/pages/ListOfDocuments/Modals/HistoryContract";
import Actions from "~/pages/ListOfDocuments/ui/Actions";
import { useContractTableState } from "~/pages/ListOfDocuments/hooks/useContractTableState";
import { getListOfDocumentsColumns } from "~/pages/ListOfDocuments/model/tableAdapter";
import { REGISTER_OF_DOCS_OPTION } from "~/pages/ListOfDocuments/options";
import { TableV2 } from "~/shared/ui/TableV2";

import { AccessIProps } from "..";

import styles from "~/pages/ListOfDocuments/styles.less";

const Agreements = ({ access }: { access: AccessIProps }) => {
  const { t } = useTranslation();
  const {
    data,
    isLoading,
    page,
    count,
    typeModal,
    dealerObj,
    getEvent,
    handleCount,
    handlePage,
    closeModal,
    closeModalRefetch,
  } = useContractTableState("additional");

  const columns = getListOfDocumentsColumns(t, REGISTER_OF_DOCS_OPTION);
  const rowActions = (record: any) => (
    <Actions access={access} record={record} getEvent={getEvent} />
  );

  return (
    <>
      <TableV2
        wrapperClassName={styles.tableWrapper}
        columns={columns}
        dataSource={data?.formatData ?? []}
        rowKey={(record: any) =>
          record.contractId ? `c_${record.contractId}` : `d_${record.id}`
        }
        loading={isLoading}
        pagination={false}
        rowActions={rowActions}
        actionsPlacement="left"
        actionsFixed
        scroll={{ x: "max-content" }}
      />
      <Pagination
        count={count}
        page={page + 1}
        totalCount={data?.totalCount ?? 0}
        onChangeCount={handleCount}
        onChangePage={handlePage}
      />
      {dealerObj && typeModal === "create" && (
        <CreateAdditional
          open
          onClose={closeModalRefetch}
          dealerObj={dealerObj}
        />
      )}
      {typeModal === "createArr" && (
        <CreateAdditionalArr open onClose={closeModalRefetch} />
      )}
      {dealerObj && typeModal === "edit" && (
        <EditAdditional
          open
          onClose={closeModalRefetch}
          dealerObj={dealerObj}
          print={access.print}
        />
      )}
      {dealerObj && typeModal === "history" && (
        <HistoryContract open onClose={closeModal} dealerObj={dealerObj} />
      )}
    </>
  );
};

export default Agreements;
